export default "__VITE_ASSET__DLJrLX9n__"